/**
 * Origine pubblica del sito (slash finale), da VUE_APP_API_ENDPOINT in .env.
 * Esempio: https://raromodica.it/ oppure http://localhost:8080/
 */
const raw = process.env.VUE_APP_API_ENDPOINT || "";
export const SITE_BASE =raw? raw.replace(/\/+$/, "") + "/" : "";

export function siteApiUrl(path) {
  const p = String(path).replace(/^\/+/, "");
  return SITE_BASE + p;
}

export function contactMailHref() {
    return "mailto:info@raromodica.it";
}

export function contactMailLabel() {
    return "INFO@RAROMODICA.IT";
}
